import {
  EntityListContentItem,
  EntityListProductInputData,
  EntityListTypeSupported,
  getEntityListSpecification,
} from '../../entityListsLib';
import React, { useCallback, useMemo } from 'react';
import { ImportedItemRow } from '../../../../../lib/imports/importTypes';
import { ColumnsType } from 'antd/es/table';
import { DataTable } from '@ydistri/ds';

const virtualTableScroll = { y: 460, x: 600 };

interface EntityListParsedItemsTableProps {
  entityListType: EntityListTypeSupported;
  items?: ImportedItemRow<EntityListProductInputData>[];
}

const EntityListParsedItemsTable: React.FC<EntityListParsedItemsTableProps> = ({
  entityListType,
  items,
}) => {
  const spec = getEntityListSpecification(entityListType);

  const tableColumns = useMemo((): ColumnsType<ImportedItemRow<EntityListProductInputData>> => {
    const structure = spec.getContentTableStructure();

    const result: ColumnsType<ImportedItemRow<EntityListProductInputData>> = [
      {
        key: 'rowNumber',
        title: 'Row',
        dataIndex: 'rowNumber',
        align: 'center',
        width: 60,
      },
    ];

    if (structure.includes(EntityListContentItem.PRODUCT)) {
      result.push({
        key: 'product',
        title: 'Product',
        dataIndex: ['inputData', 'product'],
        width: 100,
      });
    }

    if (structure.includes(EntityListContentItem.STORE)) {
      result.push({
        key: 'store',
        title: 'Store',
        dataIndex: ['inputData', 'store'],
        width: 100,
      });
    }

    if (structure.includes(EntityListContentItem.QUANTITY)) {
      result.push({
        key: 'count',
        title: 'Quantity',
        dataIndex: ['inputData', 'count'],
        width: 90,
      });
    }

    result.push({
      key: 'errors',
      title: 'Errors',
      render: (record: ImportedItemRow<EntityListProductInputData>) =>
        record.errors ? record.errors.join(', ') : '',
      width: 390,
    });

    return result;
  }, [spec]);

  const rowClassProvider = useCallback((record: ImportedItemRow<EntityListProductInputData>) => {
    if (record.isError) {
      return 'red';
    } else {
      return 'green';
    }
  }, []);

  const rowKeyProvider = useCallback(
    (row: ImportedItemRow<EntityListProductInputData>) => row.rowNumber,
    [],
  );

  if ((items?.length ?? 0) > 0) {
    return (
      <DataTable<ImportedItemRow<EntityListProductInputData>>
        id="RedistributionImportParsedItems"
        columns={tableColumns}
        dataSource={items}
        showHeader
        showBorder
        flexGrow={1}
        rowClassName={rowClassProvider}
        rowKey={rowKeyProvider}
        virtual
        scroll={virtualTableScroll}
      />
    );
  }
};

export default EntityListParsedItemsTable;
